module.exports = __webpack_public_path__ + "img/hi-low.a8a42ae.jpg";